<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				任务详情
				<span v-if="baseForm.sourceOrg=='HY'" style="color: #FF4D4F;display: inline-block;">该任务经由海因科技确认，推送到灵活用工系统中</span>
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" :model="baseForm" @keyup.enter.native="getDataList()" style="text-align: right;">

					<el-form-item><el-button v-if="role=='OPERATE'" type="primary" @click="downloadVoucher(baseForm.id)">下载商户上线及任务发布信息表</el-button></el-form-item>
					<!-- <el-form-item><el-button v-if="role=='OPERATE'" type="primary" @click="saveData(baseForm.id)">保存</el-button></el-form-item> -->
					<el-form-item><el-button v-if="$hasPermission('plat:plattask:checked') && role=='OPERATE'" v-show="baseForm.status===1" type="primary" @click="baseFormSubmitHandle('2',baseForm.id)">审核并接受</el-button></el-form-item>
					<el-form-item><el-button v-if="$hasPermission('plat:plattask:checked') && role!='OPERATE'" v-show="baseForm.status===1" type="primary" @click="baseFormSubmitHandle('1',baseForm.id)">通过审核</el-button></el-form-item>
					<el-form-item><el-button v-if="$hasPermission('plat:plattask:checked')" v-show="baseForm.status===1" type="danger" style="background-color: thistle" @click="baseFormSubmitHandle('0',baseForm.id)">驳回</el-button></el-form-item>
					<el-form-item><el-button v-if="$hasPermission('plat:plattask:close')" v-show="baseForm.status===2" type="primary" @click="baseFormCloseHandle(baseForm.id)">关闭任务</el-button></el-form-item>
					<el-form-item><el-button class="refreshBtn" style="left: 500px;" type="info" @click="handleExport()">导出</el-button></el-form-item>
					<el-form-item><el-button class="refreshBtn" style="left: 500px;" type="info" @click="getInfo()">刷新</el-button></el-form-item>
					<el-form-item><el-button class="refreshBtn" style="left: 500px;" type="info" @click="handleNext()">返回</el-button></el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<div style="padding: 50px;">
		<el-form :model="ruleForm" ref="ruleForm" :rules="rules" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
			<el-row>
				<el-form-item label="任务名称">
					<div class="itemInpWap"   v-for="item,index in baseForm.names">
						<el-input  class="itemInp"
								   style="width: 200px;float:left; margin-top: 10px"
								   v-model="item.name"
								   disabled
								   placeholder="请输入任务名称" >
						</el-input>
						<div class="itemBtn" style="float: left;margin-top: 10px;width: 90px">
							<el-button style="margin-left: 10px"  disabled  class="el-icon-plus btn-plus" ></el-button>
							<el-button style="margin-right: 10px"  disabled  v-if="index>0"  class="el-icon-minus btn-plus" ></el-button>
						</div>
					</div>
				</el-form-item>
			</el-row>
			<el-row>
				<el-col :md="12" :lg="12">
					<el-form-item label="任务大类" prop="taskType"><ren-select style="width: 91%;" v-model="baseForm.taskType" :isDisabled="true" dict-type="taskType" readonly="true"></ren-select></el-form-item>
				</el-col>
				<el-col :md="12" :lg="12">
		            <el-form-item label="合同编号" prop="contractCode">
		                <el-input style="width: 91%;" v-model="baseForm.contractCode" placeholder="合同编号" disabled="disabled"></el-input>
		            </el-form-item>
		        </el-col>
				<el-col :md="12" :lg="12">
					<el-form-item label="业务月体量" prop="monthlyVolume"><el-input style="width:91%;" v-model="baseForm.monthlyVolume" :isDisabled="true" disabled></el-input></el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :md="12" :lg="12">
					<el-form-item label="任务简述" prop="taskDesc">
					<el-input type="textarea" rows="4" style="width: 91%;" v-model="baseForm.taskDesc" placeholder="请描述您的任务具体做什么事情" disabled="disabled" show-word-limit></el-input>
					</el-form-item> 
				</el-col>
				<el-col :md="12" :lg="12">
					<el-form-item label="业务场景说明" prop="businessScenario">
					<el-input type="textarea" rows="4" style="width: 91%;" v-model="baseForm.businessScenario" placeholder="请描述您为什么需要用到灵工" disabled="disabled" show-word-limit></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		   <el-row>
			<el-col  :md="12"  :lg="12">
				<el-form-item label="结算价格及结算方式" prop="taskRequire">
					<el-input type="textarea" rows="4" style="width: 91%;" v-model="baseForm.taskRequire" placeholder="请按照格式要求说明。结算价：xx元——xx元/小时结算 ；结算方式：验收合格后，通过灵工平台进行结算 " disabled="disabled"></el-input>
				</el-form-item>
			</el-col>
			<el-col :md="12" :lg="12">
				<el-form-item label="任务计价" prop="pricingMethod">
				<el-input type="textarea" rows="4" style="width: 91%;" v-model="baseForm.pricingMethod" placeholder="请描述您的任务是以天、或者是什么单位进行结算计价以及计价方法" show-word-limit disabled="disabled"></el-input>
				</el-form-item>
			</el-col>
		   </el-row>
		   <!-- <el-row v-if="baseForm.bodyId != '1453241566079012865'">
				<el-col :sm="12" :lg="12">
					<el-form-item label="任务场景" prop="businessScenario">
						<el-input rows="6" maxlength="500" v-model="baseForm.businessScenario" show-word-limit type="textarea" disabled  placeholder="前面填公司所属行业,后面填用工场景:如市场推广、软件开发、信息服务、会议会展服务等" style="border: none;width: 91%;"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="12">
					<el-form-item label="结算价格及计算方式" prop="taskRequire">
						<el-input rows="6" maxlength="500" v-model="baseForm.taskRequire" show-word-limit type="textarea" disabled  placeholder="按项目内容,填写结算依据,例如:市场推广;基础服务结算200元/天,线下活动和品牌推广按1千-8千/次(按规模)" style="border: none;width: 91%;"></el-input>
					</el-form-item>
				</el-col>
			</el-row> -->

		    <!-- <el-row>
				<el-col :span="6">
				    <el-form-item label="需求人数" prop="requirePerson">
				        <el-input style="width: 95%;" v-model="baseForm.requirePerson" placeholder="需求人数" disabled="disabled"><i slot="suffix" style="font-style:normal;margin-right: 10px;">人</i></el-input>

				    </el-form-item>
				</el-col>
		        <el-col :span="6">
		            <el-form-item label="预算" prop="budget">
		                <el-input style="width: 95%;" v-model="baseForm.budget" placeholder="预算" disabled="disabled"><i slot="suffix" style="font-style:normal;margin-right: 10px;">元</i></el-input>
		            </el-form-item>
		        </el-col>
		        <el-col :span="6">
		            <el-form-item label="合同编号" prop="contractCode">
		                <el-input style="width: 95%;" v-model="baseForm.contractCode" placeholder="合同编号" disabled="disabled"></el-input>
		            </el-form-item>
		        </el-col>
		    </el-row> -->
		    <!-- <el-form-item label="任务周期" prop="startDate">
				<el-date-picker v-model="baseForm.startDate" disabled="disabled" start-placeholder="开始日期" align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:SS"></el-date-picker>
				  ~
				<el-date-picker v-model="baseForm.endDate" disabled="disabled" end-placeholder="结束日期" align="right"  type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:SS"></el-date-picker>
		    </el-form-item> -->
			<el-form-item prop="attachment" label="任务附件" v-if="role=='OPERATE'">
				<el-upload class="upload-demo" :action="url" :on-remove="handleRemove" :before-remove="beforeRemove" :multiple="false" :limit="1"
					:on-preview="handlePreview" :before-upload="beforeUploadHandle" :on-error="backerror"
					:on-success="successHandle" :file-list="fileList">
					<el-button size="small" type="primary" v-if="fileList.length == 0">上传上线及任务发布信息表</el-button>
					<!-- <div slot="tip" class="el-upload__tip">支持上传PDF、图片等</div> -->
				</el-upload>
			</el-form-item>
		</el-form>
<!--    v-if="baseForm.acceptDTOList && baseForm.acceptDTOList.length > 0"-->
		<el-row style="border-top: 5px solid #F3F4F4;">
			<div style="font-size: 14px;font-weight: bold;color: #333333;line-height: 40px;">任务执行情况</div>
			<el-form>
				<el-row>
					<el-col :md="8" :lg="6">
						<el-form-item label="接受方:" >
							<el-input style="width: 60%;" v-model="dataForm.assignee" placeholder="请输入接受方" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="8" :lg="6">
						<el-form-item label="身份证号码:" >
							<el-input style="width: 60%;" v-model="dataForm.idCard" placeholder="请输入身份证号码" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="8" :lg="12">
						<el-form-item label-width="0px">
							<div style="text-align: right;">
								<el-button type="primary" @click="query()">{{ $t('query') }}</el-button>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<el-table :data="dataList" style="width: 100%;">
			    <el-table-column label="序号" type="index" width="50" align="center">
			    	<template slot-scope="scope">
			    		<span>{{scope.$index + 1 }}</span>
			    	</template>
			    </el-table-column>
				<el-table-column prop="publishName" label="发布方" header-align="center" align="center"></el-table-column>
			    <el-table-column prop="contractCode" label="个人合同编号" header-align="center" align="center"></el-table-column>
			    <!-- <el-table-column prop="assignee" label="被分配方" header-align="center" align="center"></el-table-column> -->
			    <el-table-column prop="assignee" label="接受方" header-align="center" align="center"></el-table-column>
		  		<el-table-column prop="idCard" label="身份证号" header-align="center" align="center"></el-table-column>
				  <!-- <el-table-column prop="taskCode" label="任务申请编号" header-align="center" align="center"></el-table-column> -->
				  <el-table-column prop="acceptTaskCode" label="任务接收编号" header-align="center" align="center"></el-table-column>

			    <el-table-column prop="individualAmount" label="支付金额（元）" header-align="center" align="center">
					<template slot-scope="scope">
						{{Number(scope.row.individualAmount).toFixed(2)}}
					</template>
				</el-table-column>

				<!-- <el-table-column prop="finishProofPath" label="完工证明" header-align="center" align="center">
					<template slot-scope="scope">
						<el-button type="primary" v-if="scope.row.finishProofPath!=null && scope.row.finishProofPath!=''" @click="yulan(scope.row)">查看</el-button>
					</template>
				</el-table-column> -->

				<el-table-column prop="acceptDate" label="操作日期" header-align="center" align="center"></el-table-column>

				<el-table-column prop="status" label="用户任务状态" header-align="center" align="center">
					<template slot-scope="scope">
						{{ $getDictLabel("acceptTaskStatus", scope.row.status) }}
					</template>
				</el-table-column>
			</el-table>
      <el-pagination
          style="position: relative;bottom:6px;padding-top: 15px;"
          background
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"
      ></el-pagination>
		</el-row>

		<el-row style="border-top: 5px solid #F3F4F4;">
			<div style="font-size: 14px;font-weight: bold;color: #333333;line-height: 40px;">任务状态</div>
			<div style="line-height: 25px;padding: 10px 0;font-size: 12px;">
				<p style="margin: 0;">

					任务发布编号<span style="margin-left: 30px;">{{baseForm.taskCode}}</span>
					</p>
					<p style="margin: 0;border-bottom:1px solid #F3F4F4;" v-for="(value,key) in baseForm.processDTOList" :key="key" class="taskSty">
						<!-- <span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span> -->
						{{value.createDate}}
						<span style="margin-left: 40px;">{{value.createName}}</span>
						<span style="margin-left: 40px;">{{value.operation}}</span>
						<span style="margin-left: 40px;white-space: pre-line;">{{value.content.replace(/，/g,"：")}}</span>
						</p>
			</div>
		</el-row>

		</div>
		<el-dialog
				title="查看"
				:visible.sync="is_show"
				:before-close="handleClose">
					<div class="el-upload-list-wrap-my">
						<el-upload
								action=""
								accept="image/*,application/pdf,application/zip"
								list-type="picture-card"
								:file-list="fileList"
								class="imgHide"
						>
							<i slot="default" class="el-icon-plus"></i>
							<div slot="file"  slot-scope="{file}">
								<img
										v-if="showPdf(file.url)"
										class="el-upload-list__item-thumbnail"
										src="../../../assets/img/pdf.png" alt=""
								>
								<img
										v-else-if="showZip(file.url)"
										class="el-upload-list__item-thumbnail"
										src="../../../assets/img/zip.jpg" alt=""
								>
								<img
										v-else
										class="el-upload-list__item-thumbnail"
										:src="file.url" alt=""
								>
								<span class="el-upload-list__item-actions">
										<span
												v-if="showPdf(file.url)"
												class="el-upload-list__item-preview"
												@click="pdfPreview(file.url)"
										>
															  <i class="el-icon-zoom-in"></i>
															</span>
											<span
													v-else-if="showZip(file.url)"
													class="el-upload-list__item-preview"
													@click="zipPreview(file.url)"
											>
															  <i class="el-icon-download"></i>
															</span>
											<span
													v-else
													class="el-upload-list__item-preview"
													@click="handlePictureCardPreview(file)"
											>
															  <i class="el-icon-zoom-in"></i>
															</span>
						</span>
					</div>

				</el-upload>

				<el-dialog :visible.sync="previewPicDialog" append-to-body>
					<img width="100%" :src="dialogImageUrl" alt="">
				</el-dialog>
			</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="is_show = false">关 闭</el-button>
					  </span>
			
		</el-dialog>
	</el-card>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
import { Loading } from 'element-ui'
import { addDynamicRoute } from '@/router'
import mixinViewModule from "@/mixins/view-module";

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      rules: {
        optionCheck: [
          { type: 'array', required: true, message: '请勾选我已详细阅读并同意', trigger: 'change' }
        ]
      },
      num: -1,

        fileList: [],
      is_show: false,
      dialogVisible: false,
      visible: false,
      readonly: true,
      optionCheck: '', // 同意协议按钮
      ruleForm: {
        optionCheck: []
      },
      role: '',
      baseForm: {
		    id: '',
		    assignee:'',
        taskDesc: '',
        taskRequire: '',
        requirePerson: '',
        budget: '',
        contractCode: '',
        startDate: '',
        endDate: '',
        status: '',
        taskCode: '',
        processDTOList: [],
        acceptDTOList: [],
		businessScenario:'',
		monthlyVolume:''
      },
      url: `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
      dataForm: {
        id: '',
		idCard:'',
		assignee:'',
		pricingMethod:''
      },
        previewPicDialog : false,
        dialogImageUrl : "",
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/task/getTaskAcceptPage',
        getDataListIsPage: true,
        createdIsNeed: false,
      },
    }
  },
  created () {
    this.baseForm.id = this.dataForm.id = this.$route.params.id || ''
    this.num = this.$route.params.num || -1
    this.init()
    this.role = Cookies.get('admin_role')
  },
  computed: {},
  methods: {
	// 上传
	handleRemove (file, fileList) {
		for (let i = 0; i < fileList.length; i++) {
			fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
		}
		this.fileList = []
		this.baseForm.attachment = ''
		if(file.status == 'success'){
			this.saveData(this.baseForm.id)
		}
      
    },
	beforeRemove(file,fileList){
		if(file.status == 'success')
		return this.$confirm(`确定移除 ${ file.name }？`);
	},
	handlePreview (file) {
		console.log(file)
      if (!file.url) {
        this.$message.error('下载失败')
        return
      }
      const type = file.url.split('.')[4]
      // 判断文件类型
      if (type === 'doc' || type === 'docx' || type === 'xlsx' || type === 'xls' || type === 'ppt' || type ===
					'pptx') {
        // 在当前浏览器直接下载
        document.location.href = file.url
      } else {
        // 图片在浏览器打开 新的页面展示
        window.open(file.url, file.name)
      }
    },
	beforeUploadHandle (file) {
      console.log(file)
      if (file.type != 'application/pdf' && file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file
        .type !== 'image/png' && file.type !== 'image/gif' && file.type !== 'application/vnd.ms-excel' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.$message.error(this.$t('upload.tip', {
          'format': 'jpg、png、gif,pdf,xls,xlsx'
        }))
        return false
      }
      if (file.size / 1024 / 1024 > 30) {
        this.$message.error('文件太大，只能上传30MB以内的文件')
        return false
      }
      this.num++
    },
	backerror (e) {
      this.$message.error('文件上传失败，请重试')
    },
	// 上传成功
    successHandle (res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }

      for (let i = 0; i < fileList.length; i++) {
        fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
      }
      this.fileList = fileList
      this.baseForm.attachment = res.data.url
	  this.saveData(this.baseForm.id)
      this.num--
    },
	downloadVoucher(id){
		window.open(
          `${
            window.SITE_CONFIG["apiURL"]
          }/sys/plat/deal/approval/downloadBusinessTask?id=${id}&access_token=${Cookies.get(
            "access_token"
          )}`
        );
	},
	// 保存附件
	saveData(id){
		this.$http.post('/sys/plat/task/saveAttachment', {
			attachment:this.baseForm.attachment ? this.baseForm.attachment : '',
			id
		}).then(({ data: res }) => {
			console.log(res)
			if(res.code == 0){
				if(this.baseForm.attachment){
					this.$message.success('上传附件成功');
				}else{
					this.$message.success('删除附件成功');
				}
				this.getInfo();
			}else{
				this.$message.error(res.msg);
			}
		})
	},
	//   返回上级
	handleNext(){
		console.log(this.$route.params.parentId)
		if(this.$route.params.parentId){//企业开票记录详情返回
			const routeParams = {
				routeName: 'plat-platticketrecordqy__任务详情',
				title: `申请开票`,
				path: 'plat/platinvoicingtasklist-add',
				params: {
					id:this.$route.params.parentId,
					isThreeRoute:true
				}
			}
			addDynamicRoute(routeParams, this.$router)
		}else{
			this.$router.back(this.num)
		}
	},
    init () {
      this.visible = true
      this.$nextTick(() => {
        if (this.baseForm.id) {
          this.getInfo()
          this.query();
        }
      })
    },
	 setNamesFn(str){
         str = str.split(',')
        let getNames = [];
         for (var i=0;i<str.length;i++){
             getNames.push({name : str[i]})
         }
         return getNames
	 },
	 handleExport(){
		 window.open(`${window.SITE_CONFIG['apiURL']}/sys/plat/task/exportTaskAccept?id=${this.baseForm.id}&access_token=${Cookies.get('access_token')}`)
	 },
    // 获取信息
    getInfo () {
      let loadingInstance = Loading.service({})
      this.$http.get(`/sys/plat/task/${this.baseForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message({
						  message: res.msg,
						  type: 'error',
						  duration: 500,
						  onClose: () => {
              loadingInstance.close()
              this.$router.back(-1)
						  }
          })
		}
		// res.data.acceptDTOList.map((item)=>{
		// 	if(item.assignee==null){
		// 		item.assignee=''
		// 	}
		// })  这个字段暂时不用了，返回null导致下方代码不执行，导致loading无法关闭
		  res.data.names = this.setNamesFn( res.data.names)
        this.baseForm = {
          ...this.baseForm,
          ...res.data
        }
		this.fileList = this.baseForm.attachment ? [{url:this.baseForm.attachment,name:'商户上线及任务发布信息表'}] : []
		console.log(this.fileList)
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
					  loadingInstance.close()
        })
      }).catch(() => {
      })
    },
    // 分页, 每页条数
    pageSizeChangeHandle (val) {
      this.page = 1
      this.limit = val
      this.query()
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.page = val
      this.query()
    },
    baseFormCloseHandle: debounce(function (id) {
			  let _this = this
			  let submitForm = {}
			  submitForm.id = id
			  this.$http.post('/sys/plat/task/close?id=' + id, submitForm).then(({ data: res }) => {
			    if (res.code !== 0) {
			      return this.$message.error(res.msg)
			    }
			    this.$message({
			      message: this.$t('prompt.success'),
			      type: 'success',
			      duration: 500,
			      onClose: () => {
			  		this.getInfo()
			      }
			    })
			  }).catch(() => {})
    }),
    // 表单提交
    baseFormSubmitHandle: debounce(function (inStatus, id) {
			  let _this = this
			  this.$prompt('请输入审核理由', '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消'
			  }).then(({ value }) => {
        let status = inStatus
        if (inStatus == 2) {
          status = 1
        }
			    this.$http.post('/sys/plat/task/audit?inStatus=' + status + '&content=' + value + '&id=' + id, {
			      headers: {
			        'content-type': 'application/json;charset=utf-8'
			      }
			    }).then(({ data: res }) => {
			      if (res.code !== 0) {
			        return this.$message.error(res.msg)
			      }
			      this.$message({
			        message: this.$t('prompt.success'),
			        type: 'success',
			        duration: 500,
			        onClose: () => {
              // if(inStatus == 2){
              // 	// let submitForm = {}
              // 	// submitForm.taskId = id
              // 	// this.$http.post('/sys/plat/task/accept', submitForm).then(({data: res}) => {
              // 	//     if (res.code !== 0) {
              // 	//         return this.$message.error(res.msg)
              // 	//     }
              // 	// }).catch(() => {
              // 	// })
              // }
              this.getInfo()
			        }
			      })
			    }).catch(() => {})
			  })
    }),
    yulan (data) {
        let fileUrl ;
        if(data.finishProofPath){
            fileUrl = data.finishProofPath.split(',')
        }else if(data.finishProofPath2){
            fileUrl = data.finishProofPath2.split(',')
        }else{
            fileUrl = []
        }
        this.fileList = fileUrl.map(item=>{
            return {
                name:'',
                url:item
            }
        });
        this.is_show = true
    },
	  handleClose(){
		this.is_show = false;
	  },
      showPdf(url){
          if(url.split('.')[url.split('.').length-1].indexOf('pdf')>-1){
              return true
          }else{
              return false
          }
      },
      showZip(url){
          if(url.split('.')[url.split('.').length-1].indexOf('zip')>-1 || url.split('.')[url.split('.').length-1].indexOf('rar')>-1){
              return true
          }else{
              return false
          }
      },
      zipPreview(url){
          window.open(url)
      },
      pdfPreview(url){
          window.open(url)
      },
      handlePictureCardPreview(file){
          this.previewPicDialog = true;
          this.dialogImageUrl = file.url;
      },
  }
}
</script>
<style lang="scss" >
	.el-upload-list-wrap-my  .el-upload-list--picture-card{
		margin: 0;
		display: inline;
		vertical-align: top;
	}
	.el-upload-list-wrap-my .el-upload-list__item:first-child{
		margin-top: 0px !important;
	}
	.imgHide .el-upload--picture-card {
		display: none;
	}
	.uploadimgage{
		text-align: center;
		margin-top: 5px;
		display: block;
	}
	.btn-plus{
		width: 30px;
		height:30px;
		padding: 0;
		border-radius: 50%;
	}
	.itemInpWap{
		float: left;
		.itemInp{
			margin-top: 10px !important;
		}
		.itemBtn{
			float: left;
		}
	}
	.taskSty{
		display: flex;
		line-height:20px;
		padding:10px 0;
		align-items: center;
		span{
			&:last-child{
				width: 60%;
			}
		}
	}
</style>
